import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index.js'
import { eventBus } from 'rph-slides-vue/src/util/eventBus.js'

import Home from '@/views/Home.vue'
import Lists from 'rph-slides-vue/src/views/lists/ListsIndex.vue'
import List from 'rph-slides-vue/src/views/lists/ListsEdit.vue'
// import Slide from 'rph-slides-vue/src/views/slides/SlidesEdit.vue'
import Slide from '@/views/SlidesEdit.vue'
import Test from 'rph-slides-vue/src/views/Test.vue'
import Login from 'rph-slides-vue/src/views/Login.vue'
import Players from 'rph-slides-vue/src/views/PlayersIndex.vue'

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/',
    name: 'home',
    component: Home,
    beforeEnter: checkLogin
  },
  {
    path: '/lists',
    name: 'lists',
    component: Lists,
    beforeEnter: checkLogin
  },
  {
    path: '/lists/edit/:id',
    name: 'list/edit/id',
    component: List,
    beforeEnter: checkLogin
    // props: {
    //   slideComponent: 'ms-slide'
    // }
  },
  {
    path: '/lists/edit',
    name: 'list/edit',
    component: List,
    beforeEnter: checkLogin
    // props: {
    //   slideComponent: 'ms-slide'
    // }
  },
  {
    path: '/slide/edit/:listId/:slideId',
    name: 'slide/edit',
    component: Slide,
    beforeEnter: checkLogin
  },
  {
    path: '/slide/create/:listId/:index',
    name: 'slide/create',
    component: Slide,
    beforeEnter: checkLogin
  },
  {
    path: '/players',
    name: 'players',
    component: Players,
    beforeEnter: checkLogin
  },
  {
    path: '/test',
    name: 'test',
    component: Test,
    beforeEnter: checkLogin
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// Authorization ---------------------------

let entryUrl = null

eventBus.$once('login-success', () => {
  if (!Vue.prototype.$config.auth) return
  if (entryUrl && entryUrl !== '/login') {
    router.push(entryUrl)
    entryUrl = null
  } else {
    router.push('/')
  }
})

eventBus.$on('logged-out', () => {
  if (!Vue.prototype.$config.auth) return
  router.push('/login')
})

// initial Login check
// requestAnimationFrame(() => {
//   store.dispatch('auth/INITIAL_LOGIN_CHECK')
// })

export function checkLogin (to, from, next) {
  if (!Vue.prototype.$config.auth) {
    next()
    return
  }
  entryUrl = to.path
  const destination = store.getters['auth/isLoggedIn'] ? true : '/login'
  // console.log('checkLogin', store.getters['user/isLoggedIn'], destination)
  next(destination)
}

export default router
